/** @jsx builderX.jsx */

import {builderX, Sprite, Image, Button} from '@gongxigames/framework/core/fragments/BuilderX';
import {RichText, RichTextProps} from '@gongxigames/framework/core/fragments/BuilderX/components/RichText';

const buttonProps: RichTextProps = {
    name: 'showButtonText',
    localeTextID: 'buyFeature',
    style: 'BuyFeatureButtonStyle',
    position: [0, 148],
    maxWidth: 314
};

const priceProps: RichTextProps = {
    localeTextID: '',
    style: 'BuyFeaturePriceStyle',
    maxWidth: 314,
    name: 'buyFeaturePrice'
};

export default (
    <Sprite name='buyFeature'>
        <Button name='buyFeatureButton'>
            <Sprite>
                <Image src='btn_bf_normal' anchor={[0.5, 0]}/>
                <RichText {...buttonProps}/>
            </Sprite>
            <Sprite>
                <Image src='btn_bf_hovered' anchor={[0.5, 0]}/>
                <RichText {...buttonProps}/>
            </Sprite>
            <Sprite>
                <Image src='btn_bf_pressed' anchor={[0.5, 0]}/>
                <RichText {...buttonProps}/>
            </Sprite>
            <Sprite>
                <Image src='btn_bf_disabled' anchor={[0.5, 0]}/>
                <RichText {...buttonProps}/>
            </Sprite>
        </Button>
        <RichText {...priceProps}/>
    </Sprite>
);
